import React, { useEffect, useRef } from "react"; // <-- Import useEffect and useRef
import { Container, Row, Col } from "react-bootstrap";
import GreenBorderline from "../updatehackinginternship/Assets/ProcessAssets/skgreenborder.png";

// Make sure this import path is correct
import myVideo from "../updatehackinginternship/Assets/piechat/Mentorship.mp4";

function CybersecuritySection() {
  // 1. Create a ref to attach to the <video> element
  const videoRef = useRef(null);

  // 2. Set up the Intersection Observer with useEffect
  useEffect(() => {
    const videoElement = videoRef.current;

    // This is the function that runs when the element's visibility changes
    const callback = (entries) => {
      const [entry] = entries; // Get the first (and only) entry

      if (entry.isIntersecting) {
        // --- User scrolled TO the video ---
        // Start playing. 'catch' handles potential browser errors.
        videoElement.play().catch((error) => {
          console.warn("Video autoplay was prevented by browser.", error);
        });
      } else {
        // --- User scrolled AWAY from the video ---
        // Pause it
        videoElement.pause();
      }
    };

    // --- Observer options ---
    // 'threshold: 0.5' means the callback will run when 50%
    // of the video is visible on the screen.
    const options = {
      root: null, // observing relative to the viewport
      rootMargin: "0px",
      threshold: 0.5, // Run callback when 50% of the video is in view
    };

    // 3. Create the observer and start observing
    const observer = new IntersectionObserver(callback, options);

    if (videoElement) {
      observer.observe(videoElement);
    }

    // 4. Cleanup: Stop observing when the component unmounts
    return () => {
      if (videoElement) {
        observer.unobserve(videoElement);
      }
    };
  }, []); // The empty array [] means this effect runs only once on mount

  // --- Internal CSS Styles (No changes) ---
  const styles = {
    section: {
      fontFamily: "Arial, sans-serif",
    marginTop: "50px",
      backgroundColor: "#ffffff",
      overflow: "hidden",
    },
    eyebrow: {
      color: "#F59E0B",
      fontWeight: "bold",
      fontSize: "0.9rem",
      letterSpacing: "0.5px",
      textTransform: "uppercase",
      marginBottom: "0.5rem",
    },
    heading: {
      fontSize: "clamp(2rem, 5vw, 2.8rem)",
      fontWeight: "bold",
      lineHeight: 1.2,
      marginBottom: "1.5rem",
      color: "#333",
    },

    bodyText: {
      fontSize: "1.1rem",
      color: "#555",
      lineHeight: 1.6,
      marginBottom: "1.5rem",
    },
    highlight: {
      fontWeight: "bold",
      fontStyle: "italic",
      color: "#000",
    },
    videoCol: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    video: {
      width: "100%",
      maxWidth: "800px",
      height: "auto",
      borderRadius: "8px",
    },
  };
  // ---------------------------

  return (
    < div style={styles.section}>
      <Row className="container align-items-center">
        {/* --- Left Text Column --- */}
        <Col md={12} lg={6}>
          <p style={styles.eyebrow}>CYBERSECURITY BOOTCAMP SYLLABUS</p>
          <h1 style={styles.heading}>
            100% Practical Curriculum. <span>0% Fluff</span>
          </h1>
          <img
            src={GreenBorderline}
            alt="GreenBorderline"
            style={{ width: "250px", height: "8.59px", marginTop: "-15px" }}
          />

          <p style={styles.bodyText}>
            An average IT professional knows the theory about firewalls,
            encryption, and protocols - all of which you can learn from books.
          </p>
          <p style={styles.bodyText}>
            In this bootcamp, you{" "}
            <strong style={styles.highlight}>
              <em>learn cyber defense by doing</em>
            </strong>
            . And{" "}
            <strong style={styles.highlight}>
              <em>doing</em>
            </strong>{" "}
            so by simulating real-world attacks under the guidance of ethical
            hacking industry leaders and expert practitioners.
          </p>
        </Col>

        {/* --- Right Video Column --- */}
        <Col md={12} lg={6} style={styles.videoCol}>
          <video
            ref={videoRef} // <-- 5. Attach the ref to the video
            style={styles.video}
            // autoPlay has been removed
            muted // Muted is still required for programmatic play
            playsInline
            // loop has been removed
          >
            <source src={myVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </Col>
      </Row>
    </div>
  );
}

export default CybersecuritySection;
